import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";

import { Flex, Button, SimpleGrid, Box } from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import Group from "../Visualizar/Group";
import Information from "./InformationPerfil";

import PerfilSAService from "../../../../main/services/PerfilSAService";

import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import { useAppContext } from "../../../../Context/MessageContextProvider";

const PerfilServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const { idPJ } = useAppContext();

  useEffect(() => {
    PerfilSAService.getPerfilSA(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.message === "Registro não foi encontrado!") {
            history.push(`/servico-acolhimento/cadastrar-perfil/${id}`);
          }
        }
      });
  }, [history, id]);

  const handleRestricoes = (restricoes) => {
    if (restricoes.length > 1) {
      return restricoes
        .map((rest, index) => {
          if (
            index !== restricoes.length - 1 &&
            index !== restricoes.length - 2
          ) {
            return rest + ",";
          } else if (index === restricoes.length - 2) {
            return rest;
          } else {
            return "e " + rest;
          }
        })
        .join(" ");
    } else {
      return restricoes.join();
    }
  };

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.perfilVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loading && data ? (
      <>
        <Group title="Gênero">
          <Information
            title="Faz Restrição de Gênero?"
            information={data.restricaoGenero === "S" ? "Sim" : "Não"}
          />
          {data.restricaoGenero === "S" && (
            <Information
              title="Restrições:"
              information={handleRestricoes(JSON.parse(data.restricoes))}
            />
          )}
        </Group>
        <Group title="Faixa Etária">
          <Information
            title="Faz Restrição de Faixa Etária?"
            information={data.restricaoIdade === "S" ? "Sim" : "Não"}
          />
          {data.restricaoIdade === "S" && (
            <>
              <Information
                title="Idade Mínima Aceita Pelo Serviço:"
                information={data.idadeMinima}
              />
              <Information
                title="Idade Máxima Aceita Pelo Serviço:"
                information={data.idadeMaxima}
              />
            </>
          )}
        </Group>
        <Group title="Saúde">
          <Information
            title="Faz Restrição de Criança/Adolescente com Deficiência?"
            information={data.restricaoDeficiencia === "S" ? "Sim" : "Não"}
          />
          <Information
            title="Faz Restrição de Criança/Adolescente que faz uso de Substâncias Psicoativas?"
            information={data.restricaoSubstancias === "S" ? "Sim" : "Não"}
          />
          <Information
            title="Faz Restrição de Criança/Adolescente que Demanda Cuidados de Saúde?"
            information={data.restricaoCuidados === "S" ? "Sim" : "Não"}
          />
        </Group>
        <Group title="Capacidade">
          <Information
            title="Capacidade de Atendimento:"
            information={data.capacidadeAcolhimento}
          />
          <Information title="Vagas Ocupadas:" information="0" />
          <Information
            title="Vagas Disponíveis:"
            information={data.capacidadeAcolhimento}
          />
        </Group>

        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={servicos.perfilEditar}
            id={idPJ}
            user={user}
          >
            <Button
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              fontSize="15px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              onClick={() => {
                history.push(`/servico-acolhimento/editar-perfil/${id}`);
              }}
            >
              Editar
            </Button>
          </Permission>
        </SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default PerfilServicoAcolhimento;
